import {
  ActionButton,
  Badge,
  OfficeHeader,
  Paginator,
  RealTimeWrapper,
  Show,
  TableComponent,
} from "components";
import { useAppNavigate, useAppSearch } from "_graphql/cache/auth";

import { Action } from "components/buttons/action-button";
import ApproveContainer from "./approve";
import { BrokerOffers_brokerOffers_data } from "_graphql/queries/__generated__/BrokerOffers";
import DeclineContainer from "./reject";
import { FC } from "react";
import SendMessageContainer from "./message-thread";
import { TransactionStatus } from "_graphql/__generated__/globalTypes-place-it";
import ViewOfferSlipContainer from "./view-slip";
import config from "config";
import { extractVehicleNumberFromDetails } from "utils";
import numeral from "numeral";
import { usePagination } from "hooks";
import { usePlaceItOffers } from "hooks/data/use-placeit-offers";
import { useUpdateBubble } from "hooks/data/use-update-bubble";

type Props = {};

const PlaceIfOffersPage: FC<Props> = () => {
  const navigate = useAppNavigate();
  const searchParams = useAppSearch();
  const { currentPage, limit, setPage, offset, search } = usePagination();
  const { updateBubble } = useUpdateBubble();
  const { offers, loading, refetch, length } = usePlaceItOffers({
    brokerId: "1",
    filters: {
      page: currentPage,
      limit: limit,
      search: search || "",
    },
  });

  const dispatchAction =
    (id: string, action: Exclude<Action, "expand" | "goto" | "clone">) =>
      () => {
        navigate({
          search: (old) => ({
            ...old,
            id,
            modal: action,
          }),
        });
      };

  const updateThreadBubble = (ids: string[]) => {
    updateBubble({
      variables: {
        ids,
      },
    })
      .then(() => { })
      .catch((err) => {
      });
  };

  return (
    <RealTimeWrapper channel={config.pusher.channels.placeIt} events={["cedant.manager_onboarded", "cedant.placed_risk", "cedant.updated_risk", "cedant.uploaded_supporting_documents", "cedant.send_thread_notification", "broker.send_thread_notification", "broker.update_offer", "broker.accept_offer", "broker.declined_offer"]} callBack={(data) => {
      console.log("RealTimeWrapper callback triggered", data);
      refetch()
    }}>

      <main className="flex-1 flex flex-col overflow-hidden bg-background-500">
        <OfficeHeader />
        <div className="flex flex-1 overflow-y-auto">
          <div className="flex-1 mx-auto min-w-0  py-4 sm:py-6 overflow-hidden overflow-y-auto light flex">
            <TableComponent
              title={"Broker Offers"}
              data={offers}
              emptyMessage="No offers found"
              columns={[
                {
                  name: "Policy #",
                  accessor: "offer_detail.policy_number",
                  render: (value: BrokerOffers_brokerOffers_data) => (
                    <div>
                      <span className="font-bold text-xs">
                        {value.offer_detail?.policy_number || "N/A"}
                      </span>
                    </div>
                  ),
                },
                {
                  name: "Insurance Company",
                  accessor: "insurer.insurer_company_name",
                  render: (value: BrokerOffers_brokerOffers_data) => (
                    <div className="flex flex-col text-xs">
                      <span className="font-medium">
                        {value.insurer?.insurer_company_name || "N/A"}
                      </span>
                      <span className="font-light">
                        {value.insurer?.insurer_company_email || "N/A"}
                      </span>
                    </div>
                  ),
                },
                {
                  name: "Insured",
                  accessor: "offer_detail.insured_by",
                  render: (value: BrokerOffers_brokerOffers_data) => {
                    const details = JSON.parse(
                      value?.offer_detail?.offer_details || "[]"
                    );
                    return (
                      <div className="flex flex-col text-xs ">
                        <span className="font-medium">
                          {value.offer_detail?.insured_by || "N/A"}
                        </span>
                        <span className="font-light">
                          {[
                            "Motor Comprehensive Fleet",
                            "Motor Comprehensive",
                            "Motor Comprehensive (Automobile Fac Facility)",
                          ].includes(
                            value?.class_of_business?.business_name || ""
                          )
                            ? extractVehicleNumberFromDetails(details)
                            : ""}
                        </span>
                      </div>
                    );
                  },
                },
                {
                  name: "Class Of Business",
                  accessor: "classofbusiness.business_name",
                  render: (value: BrokerOffers_brokerOffers_data) => (
                    <div className="flex flex-col text-xs">
                      <span className="font-medium">
                        {value.class_of_business?.business_name || "N/A"}
                      </span>
                    </div>
                  ),
                },
                {
                  name: "Sum Insured",
                  accessor: "sum_insured",
                  render: (value: BrokerOffers_brokerOffers_data) => (
                    <div className="flex flex-col text-xs">
                      <span className="font-medium">
                        {value?.offer_detail?.currency}{" "}
                        {numeral(value.sum_insured).format("0,0 ") || "N/A"}
                      </span>
                    </div>
                  ),
                },
                {
                  name: "Premium",
                  accessor: "premium",
                  render: (value: BrokerOffers_brokerOffers_data) => (
                    <div className="flex flex-col text-xs">
                      <span className="font-medium">
                        {value?.offer_detail?.currency}{" "}
                        {numeral(value.premium).format("0,0 ") || "N/A"}
                      </span>
                    </div>
                  ),
                },
                {
                  name: "Offer Date",
                  accessor: "created_at",
                  render: (value: BrokerOffers_brokerOffers_data) =>
                    new Date(value.created_at).toLocaleDateString(),
                },
                // {
                //     name: "Offer Status",
                //     accessor: "payment_status",
                //     render: (value: BrokerOffers_brokerOffers_data) => (
                //         <Badge status={
                //             value.offer_status === Offer_status.ACCEPTED ? "success" :
                //                 value.offer_status === Offer_status.REJECTED ? "error" :
                //                     value.offer_status === Offer_status.PENDING ? "warning" :
                //                         value.offer_status === Offer_status.INITIATED ? "neutral" :
                //                             "neutral"
                //         } tooltip={`Rejected by ${value?.offer_approval_state?.employee_name || "N/A"}`}
                //             showToolTip={["REJECTED"].includes(value.offer_status || "")}
                //             label={value.offer_status || "N/A"} />
                //     )
                // },
                // {
                //     name: "Payment Status",
                //     accessor: "payment_status",
                //     render: (value: BrokerOffers_brokerOffers_data) => (
                //         <Badge status={
                //             value.payment_status === Payment_status.PAID ? "success" :
                //                 value.payment_status === Payment_status.UNPAID ? "error" : "warning"

                //         } label={value.payment_status || "N/A"} />
                //     )
                // },
                {
                  name: "Transaction Status",
                  accessor: "transaction_status",
                  render: (value: BrokerOffers_brokerOffers_data) => (
                    <Badge
                      status={
                        value.transaction_status === TransactionStatus.APPROVED
                          ? "success"
                          : value.transaction_status ===
                            TransactionStatus.REJECTED
                            ? "error"
                            : value.transaction_status ===
                              TransactionStatus.INITIATED
                              ? "sky"
                              : value.transaction_status === TransactionStatus.MODIFY
                                ? "orange"
                                : "neutral"
                      }
                      label={value.transaction_status || "N/A"}
                      tooltip="View Message Thread"
                    />
                  ),
                },
                {
                  name: "Underwriter",
                  accessor: "employee.employee_first_name",
                  render: (value: BrokerOffers_brokerOffers_data) => (
                    <div className="flex flex-row leading-0">
                      <span>
                        {value?.insurer_associate?.assoc_first_name}{" "}
                        {value?.insurer_associate?.assoc_last_name}
                      </span>
                    </div>
                  ),
                },
                {
                  name: "Actions",
                  accessor: "actions",
                  render: (value: BrokerOffers_brokerOffers_data) => (
                    <>
                      <ActionButton
                        action="chat"
                        tooltip="View Message Thread"
                        onClick={dispatchAction(value?.id, "send")}
                        count={
                          value.thread_notifications?.filter(
                            (item) => item?.status !== "READ"
                          ).length
                        }
                        callBack={() =>
                          updateThreadBubble(
                            value.thread_notifications?.map(
                              (item) => item?.id || ""
                            ) || []
                          )
                        }
                      />
                      <ActionButton
                        action="clone"
                        tooltip="View Placing slip"
                        onClick={dispatchAction(value?.id, "view")}
                      />
                      <Show
                        if={
                          value?.transaction_status ===
                          TransactionStatus.APPROVED ||
                          value?.transaction_status ===
                          TransactionStatus.PREAPPROVED
                        }
                      >
                        <>
                          <ActionButton
                            action="approve"
                            tooltip="Accept Offer"
                            onClick={dispatchAction(value?.id, "approve")}
                          />
                          <ActionButton
                            action="close"
                            tooltip="Reject Offer"
                            extraClassName="text-red-500"
                            onClick={dispatchAction(value?.id, "reject")}
                          />
                        </>
                      </Show>
                    </>
                  ),
                },
              ]}
              refetch={refetch}
              loading={loading}
              hasSearch
              pagination={() => (
                <Paginator
                  offset={offset}
                  limit={limit}
                  totalItems={length}
                  currentSize={offers.length}
                  setOffset={setPage}
                />
              )}
            />
          </div>
        </div>
        {searchParams?.id && searchParams?.modal === "approve" && (
          <ApproveContainer
            open={true}
            setOpen={(value) =>
              navigate({
                search(prev) {
                  return {
                    ...prev,
                    modal: value ? "approve" : undefined,
                    id: value ? searchParams?.id : undefined,
                  };
                },
              })
            }
          />
        )}
        {searchParams?.id && searchParams?.modal === "reject" && (
          <DeclineContainer
            open={true}
            setOpen={(value) =>
              navigate({
                search(prev) {
                  return {
                    ...prev,
                    modal: value ? "reject" : undefined,
                    id: value ? searchParams?.id : undefined,
                  };
                },
              })
            }
          />
        )}
        {searchParams?.id && searchParams?.modal === "send" && (
          <SendMessageContainer
            open={true}
            setOpen={(value) =>
              navigate({
                search(prev) {
                  return {
                    ...prev,
                    modal: value ? "send" : undefined,
                    id: value ? searchParams?.id : undefined,
                  };
                },
              })
            }
          />
        )}
        {searchParams?.id && searchParams?.modal === "view" && (
          <ViewOfferSlipContainer
            open={true}
            setOpen={(value) =>
              navigate({
                search(prev) {
                  return {
                    ...prev,
                    modal: value ? "view" : undefined,
                    id: value ? searchParams?.id : undefined,
                  };
                },
              })
            }
          />
        )}
      </main>
    </RealTimeWrapper>

  );
};

export default PlaceIfOffersPage;
